import { API_ENDPOINT } from "../constants/modal";

interface IVisionCheckBody {
  user: {
    id: string;
    answers: {
      usual_size: {
        value: string | null;
        system: string;
      };
    };
  };
}

export const isOnline = () => {
  return navigator.onLine;
};

export const putS3 = async (url: string, data: any) => {
  if (!data) {
    console.log("no data to put in S3");
    return false;
  }
  if (!url) {
    console.log("no url found");
    return false;
  }

  try {
    const fetchResponse = await fetch(data);
    const blob = await fetchResponse.blob();
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": blob.type || "image/jpeg",
      },
      body: blob,
    });

    if (!response.ok) {
      console.error("Upload failed", response);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error uploading file:", error);
    return false;
  }
};

export const visionCheck = async (user_id: string) => {
  if (!user_id) return;

  try {
    if (user_id) {
      const response = await fetch(`${API_ENDPOINT}shoe/measure/vision/check`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user: {
            id: user_id,
          },
        }),
      });

      if (!response.ok) {
        console.log(`Server error: ${response.status}`);
      }

      const res = await response.json();

      return res;
    }
  } catch (error: any) {
    if (
      error.message.includes("Failed to fetch") ||
      error.message.includes("No internet connection")
    ) {
      throw error;
    }

    return false;
  }
};

export const visionInit = async (user_id: string) => {
  try {
    if (user_id) {
      const success = await fetch(`${API_ENDPOINT}shoe/measure/vision/init`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user: {
            id: user_id,
          },
        }),
      })
        .then((res) => res.json())
        .then((res) => res)
        .catch((e) => {
          console.log("Error: visionInit - ", e);
          return false;
        });
      console.log("TCL: visionInit -> success", success);
      return success;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error with visionInit:", error);
    return false;
  }
};

export interface VisionTriggerResult {
  success: boolean;
  // Why the scan was refused: the backend's reason, else the HTTP status.
  reason?: string;
}

export const visionTrigger = async (
  userObject: IVisionCheckBody
): Promise<VisionTriggerResult> => {
  try {
    if (userObject?.user?.id) {
      return await fetch(`${API_ENDPOINT}shoe/measure/vision/trigger`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userObject),
      })
        .then(async (res) => {
          const body = await res.json().catch(() => null);
          if (body?.success) return { success: true };
          const reason =
            body?.error?.detail?.reason ||
            body?.error?.message ||
            (res.ok ? "rejected" : `http_${res.status}`);
          return { success: false, reason: String(reason) };
        })
        .catch((e) => {
          console.log("Error: visionTrigger - ", e);
          return { success: false, reason: "network" };
        });
    } else {
      return { success: false, reason: "no_uid" };
    }
  } catch (error) {
    console.error("Error with visionTrigger:", error);
    return { success: false, reason: "exception" };
  }
};
